import { render, staticRenderFns } from "./live-broadcast-login.vue?vue&type=template&id=d4996e58&scoped=true&"
import script from "./live-broadcast-login.vue?vue&type=script&lang=js&"
export * from "./live-broadcast-login.vue?vue&type=script&lang=js&"
import style0 from "./live-broadcast-login.vue?vue&type=style&index=0&id=d4996e58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4996e58",
  null
  
)

export default component.exports